var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"emptycontent"}},[_vm._t("default",function(){return [_vm._v(" "+_vm._s(_vm.t('mail', 'No messages')))]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }